import { Route, redirect } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';
import { isFeatureEnabled } from '@apply/store/src/user/types';
import { TemplateType, FeatureType } from '@apply/constants';
import store from '@apply/adminStore';

import TablesPage from '../../../templates/TablesPage';
import TemplatesLanding from '../../../templates/TemplatesLanding';

function noticesLoader() {
    const { user } = store.getState();
    if (!isFeatureEnabled(user, FeatureType.Notices)) {
        return redirect('/templates');
    }
    return null;
}

export default function TemplatesRoutes() {
    return (
        <>
            <Route
                path='/templates/icca'
                element={
                    <RequireAdmin>
                        <TablesPage templateTypeId={TemplateType.ICCA} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/templates/termsheets'
                element={
                    <RequireAdmin>
                        <TablesPage templateTypeId={TemplateType.Termsheets} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/templates/agreements'
                element={
                    <RequireAdmin>
                        <TablesPage templateTypeId={TemplateType.UserAgreements} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/templates/notices'
                loader={noticesLoader}
                element={
                    <RequireAdmin>
                        <TablesPage templateTypeId={TemplateType.Notices} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/templates'
                element={
                    <RequireAdmin>
                        <TemplatesLanding />
                    </RequireAdmin>
                }
            />
        </>
    );
}
